import * as React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './loader.css';
import { ArthLogo } from '../../assets/img/index';

export default function Loader() {
  return (
    <Container className="text-center" style={{ height: '100vh' }}>
      <Row className="justify-content-center align-items-center" style={{ height: '100%' }}>
        <Col xs="auto">
          <div className="centerLoader">
            <div className="circleLoader pulseLoader roseLoader">
              <div className='rose-color'>
                <ArthLogo />
              </div>
            </div>
          </div>
          <div>Please Wait....</div>
        </Col>
      </Row>
    </Container>
  );
}
